"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatWithDecimals = void 0;
var currency_formatter_1 = require("currency-formatter");
var FormatCurrency_1 = require("./FormatCurrency");
var formatWithDecimals = function (amount, currency, _a) {
    var _b, _c;
    var _d = _a === void 0 ? {} : _a, _e = _d.round, round = _e === void 0 ? true : _e, _f = _d.showDecimalPlaces, showDecimalPlaces = _f === void 0 ? true : _f, _g = _d.locale, locale = _g === void 0 ? undefined : _g;
    var idealDecimalPlaces = (_c = (_b = (0, currency_formatter_1.findCurrency)(currency)) === null || _b === void 0 ? void 0 : _b.decimalDigits) !== null && _c !== void 0 ? _c : 0;
    var actualDecimalPlaces = getDecimalPlaces(amount);
    var decimalPlaces = 0;
    if (!showDecimalPlaces && actualDecimalPlaces === 0) {
        decimalPlaces = 0;
    }
    else if (!round && actualDecimalPlaces > idealDecimalPlaces) {
        decimalPlaces = actualDecimalPlaces;
    }
    else {
        decimalPlaces = idealDecimalPlaces;
    }
    return (0, FormatCurrency_1.formatCurrency)(amount, currency, { precision: decimalPlaces, locale: locale });
};
exports.formatWithDecimals = formatWithDecimals;
var getDecimalPlaces = function (amount) {
    if (amount == null || Math.floor(amount) === amount) {
        return 0;
    }
    var strRepr = amount.toString().split(".")[1];
    if (strRepr == null) {
        return 0;
    }
    else {
        return strRepr.length;
    }
};
